import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fw-bold" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed, ref, watch, PropType, onMounted } from 'vue';
import { useQueueStore } from '@/stores/queueStore';
import { debounce } from "vue-debounce";


export default /*@__PURE__*/_defineComponent({
  __name: 'QueuePauseButton',
  props: {
    showPauseResumeButton: {},
    containerClass: {}
  },
  setup(__props: any) {

const props = __props
const queueStore = useQueueStore();
const isPaused = ref(false);
var tooltipText = ref("Click here to pause the queue");
var updateQueueStatus = debounce(() => getQueueStatus(), "2000ms");

const currentTooltipText = computed(()=> { return tooltipText.value; });

function setToolTipText(){
    if(isPaused.value){
        tooltipText.value = "Click here to resume the queue";
    }
    else {
        tooltipText.value = "Click here to pause the queue";
    }   
} 

function getQueueStatus(){
    queueStore.getQueueStatus().then((result) => {
        if(result != undefined && typeof(result.data) == 'boolean') {
            isPaused.value = result.data;
        }

        setToolTipText();
    }).finally(()=>{

        updateQueueStatus();
    });
}

function handlePauseResumeClick(){

    queueStore.changeQueueStatus(!isPaused.value).then(() => {
        getQueueStatus();
    });
}

onMounted(() => {

    getQueueStatus();
});


return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.containerClass),
    style: {"width":"max-content"}
  }, [
    _createElementVNode("label", null, [
      _cache[0] || (_cache[0] = _createTextVNode("Current Queue Status: ", -1)),
      _createElementVNode("span", _hoisted_1, _toDisplayString(isPaused.value ? 'Paused' : 'Running'), 1)
    ]),
    (_ctx.showPauseResumeButton)
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-link",
          onClick: _withModifiers(handlePauseResumeClick, ["prevent"])
        }, [
          (!isPaused.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "bi bi-pause-fill" }, null, -1)
              ])))
            : _createCommentVNode("", true),
          (isPaused.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "bi bi-play-fill" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ])), [
          [_directive_tooltip, currentTooltipText.value]
        ])
      : _createCommentVNode("", true)
  ], 2))
}
}

})